export default __webpack_public_path__ + "static/tags-anatomy-light-e619a3e8cac8c798b7fd59429821edb0653fb26267f9b3d59fd307007a717058.png";